import type React from 'react';

import { Checkbox, FormField, FormHelp, Label, LabeledControl, Switch } from '@zillow/constellation';

import { CenteredHR } from '../../../Widgets/CenteredHR';

type Props = {
  children?: React.ReactNode;
  title: string;
  caption: string;
  switchTitle: string;
  switchedOn: boolean;
  toggleSwitch: () => void;
};

export default function AdditionalRulesTemplate({
  title,
  caption,
  switchTitle,
  switchedOn,
  toggleSwitch,
  children,
}: Props): JSX.Element {
  return (
    <>
      <FormField
        label={<Label>{title}</Label>}
        control={
          <LabeledControl
            fluid
            labelPosition="left"
            label={<Label>{switchTitle}</Label>}
            control={
              <Switch
                aria-label="Toggle additional rules"
                size="lg"
                controlId="Switch"
                onClick={toggleSwitch}
                checkbox={<Checkbox checked={switchedOn} />}
              />
            }
          />
        }
        description={<FormHelp>{caption}</FormHelp>}
      />
      {children && <CenteredHR />}
      {children}
    </>
  );
}
